/* @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Link, Typography, breakpoints } from '@coursera/cds-core';

import CollectionsSection from 'bundles/browse/components/CollectionsSection';
import type { DiscoveryCollection } from 'bundles/browse/components/types/DiscoveryCollections';
import { TrackedLink2 } from 'bundles/page/components/TrackedLink2';

const styles = {
  section: css`
    background-color: var(--cds-color-grey-25);
    padding: 0 var(--cds-spacing-300);
    overflow: hidden;
  `,
  collectionTitle: css`
    margin-bottom: 12px;
  `,
  collectionLink: css`
    display: block;
    padding-top: 50px;
    ${breakpoints.down('sm')} {
      padding-bottom: 50px;
    }
  `,
};

type Props = {
  title: string;
  linkTitle?: string;
  linkHref?: string;
  collection?: DiscoveryCollection | null;
};

const RecommendationsModule = ({ title, linkTitle, linkHref, collection }: Props) => {
  if (!collection) {
    return null;
  }

  const collectionWithMetadata = {
    ...collection,
    metadata: {
      footer: linkTitle && linkHref && (
        <Link
          component={TrackedLink2}
          href={linkHref}
          trackingName={`${collection.id}_cta`}
          iconPosition="after"
          variant="quiet"
          typographyVariant="subtitleMedium"
          css={styles.collectionLink}
        >
          {linkTitle}
        </Link>
      ),
      header: (
        <Typography variant="h2semibold" component="h3" css={styles.collectionTitle}>
          {title}
        </Typography>
      ),
    },
  };

  return (
    <section css={styles.section}>
      <CollectionsSection collections={[collectionWithMetadata]} />
    </section>
  );
};

export default RecommendationsModule;
